export default "__VITE_ASSET__CaGW8wZ3__"